import { faSquareExclamation } from "@jewlr/pro-light-svg-icons/faSquareExclamation"
import PropTypes from "prop-types"
import { useSelector } from "react-redux"

import FontAwesomeIcon from "components/ui/font-awesome-icon"

const ErrorGroup = ({ pref }) => {
  const choices = useSelector((state) => state.choices)
  const wizardData = useSelector((state) => state.wizard?.data)

  const errors = []
  const choiceKey = pref === "diamond" ? "s1" : pref

  if (choices?.[choiceKey]?.error) {
    errors.push(choices[choiceKey].error)
  }

  if (wizardData?.[pref]?.engravings) {
    wizardData[pref].engravings.forEach((engraving) => {
      if (choices?.[engraving.pref]?.error) {
        errors.push(choices[engraving.pref].error)
      }
    })
  }

  if (errors.length === 0) return null

  return (
    <div className="text-error text-14 mb-16 flex items-center gap-6 font-medium italic">
      <FontAwesomeIcon className="text-16" icon={faSquareExclamation} />
      <div>
        {errors.map((error, i) => (
          <p key={i}>{error}</p>
        ))}
      </div>
    </div>
  )
}

ErrorGroup.propTypes = {
  pref: PropTypes.string.isRequired,
}

export default ErrorGroup
